"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Nav = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Nav = exports.Nav = _styledComponents["default"].nav.attrs({
  role: 'navigation'
}).withConfig({
  displayName: "Nav",
  componentId: "sc-165gcru-0"
})(["", ";background-color:var(--background-base,", ");color:var(--text-subdued,", ");display:flex;flex-direction:column;overflow-wrap:break-word;@media (min-width:", "){height:100vh;padding-block:", ";position:relative;inline-size:", ";}.docs-story &{block-size:100%;}"], (0, _index.rootStyle)(), _index.defaultColorSet.background.base, _index.defaultColorSet.text.subdued, _encoreFoundation.screenSmMin, _index.sidebarPadding, _index.sidebarBaseWidth);